// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1JtKo","resendInfoText":"OnGoingPaymentBox_resendInfoText__3BReJ"};